import styled from '@emotion/styled';
import { applyNonOpaqueStyleRecursive } from '@utils/opacity';
import { useEffect, useRef } from 'react';

import Icon from './icon';

const Container = styled.div`
    opacity: 1;
`;

export const LockedIcon = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        applyNonOpaqueStyleRecursive(ref.current);
    }, []);

    return (
        <Container ref={ref}>
            <Icon name='locked' />
        </Container>
    );
};
